export const  DEFAULT_WL_ALLOWED_TAGS =
{
  '*': ['id', 'name', 'target', 'class', 'style', 'wl-route', 'onclick', 
  'cellspacing', 'cellpadding', 'valign', 'align', 'bgcolor', 
  'href', 'src', 'srcset', 'alt', 'title', 'width', 'height', 'loading', 'aria-label','type',
'for'],
    // div : ['id', 'class', 'style'],
    // i : ['class', 'id', 'style'],
    // a : ['href', 'name', 'target', 'class', 'style', 'wl-route','id', 'onclick'],
    // nav :['class', 'style'],
    // img : [
    //   'align',
    //   'src',
    //   'srcset',
    //   'alt',
    //   'title',
    //   'width',
    //   'height',
    //   'loading',
    //   'style',
    // ],
    // ol : ['class', 'style'],
    // ul : ['class', 'style'],
    // li :['class', 'style'],
    // button : ['class', 'style', 'onclick', 'wl-route'],
    // table : ['class', 'width', 'cellspacing', 'cellpadding', 'style', 'align', 'bgcolor'],
    // td : ['valign', 'style', 'align'],
    // footer: ['class', 'style'],
    // span: ['class', 'style'],
    // p : ['style','class'],
    // s : ['style','class'],
    // sup : ['style','class'],
    // sub : ['style','class'],
    // strong: ['style','class']
};
